/**
 * Created by 唐亦慧 on 2018/2/6.
 */
import React from 'react';

class MallPay extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px'
		}
		this.resize = this.resize.bind(this);
	}
	
	
	componentDidMount() {
		window.onresize = this.resize;
	}
	
	resize() {
		this.setState({mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px'})
	}
	
	render() {
		return <div style={{minHeight: this.state.mainHeight, background: '#fff'}}>
			{this.props.children}
		</div>
	}
}
;
export default MallPay;


// WEBPACK FOOTER //
// ./src/mall/mallPay/index.js